export const BIDDING_STRATEGIES_ROUTES = Object.freeze({
    STRATEGIES: 'STRATEGIES',
    PSBATADMINPERIODS: 'PSBATADMINPERIODS',
    PSBATADMINPRODUCTS: 'PSBATADMINPRODUCTS',
    PSBATADMINDAYTYPES: 'PSBATADMINDAYTYPES',
});

export const ECONOMIC_RESERVE_ROUTES = Object.freeze({
    PSECONRESERVE: 'PSECONRESERVE',
    PSECONRES: 'PSECONRES',
});

export const FUEL_EMISSIONS_ROUTES = Object.freeze({
    PSBLENDS: 'PSBLENDS',
    PSFUELEMISSIONRATES: 'PSFUELEMISSIONRATES',
});

export const HYDRO_PROJECT_ROUTES = Object.freeze({
    PLANT_CONFIG: 'PSHYDPROPLACON',
    PLANT_DATA: 'PSHYDPROPLADAT',
    PROJECT_CONSTRAINTS: 'PSHYDPROCON',
    ELEVATION_CAPACITY: 'PSHYDPROELECAP',
    UNIT_RATINGS_AND_DATA: 'PSHYDPROURD',
    UNIT_OUTAGES: 'PSHYDPROUNIOUT',
});

export const RESOURCE_PLANNING_ROUTES = Object.freeze({
    ECONOMIC_ASSUMPTION: 'PSPLANMACROECON',
    OBJECTIVE_FUNCTION: 'PSPLANOBJFUNC',
    PLANNING_CONSTRAINTS: 'PSPLANCONSTSET',
    PROJECT_DETAILS: 'PSPLANNEWPROJECT',
});

export const USER_MANAGEMENT_ROUTES = Object.freeze({
    USER: 'user',
    GROUPS: 'groups',
    BOOKS: 'books',
});
